import { Dimensions, Keyboard } from 'react-native';
import {
  Colors,
  createCreateUseModal,
  Flex,
  IconCircleCheckFilled,
  PrimaryButton,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { isWeb } from 'shared/src/utils';

type RecoveryIdResultParam = {
  email: string;
};

const RecoveryIdResultContent = ({
  confirm,
  param,
}: {
  confirm: () => void;
  cancel: () => void;
  param: RecoveryIdResultParam;
}) => {
  const { width } = useScreenSize();

  return (
    <Flex.Column
      width={'auto'}
      borderRadius={12}
      backgroundColor={'content_always_white'}
      padding={{ horizontal: 16, top: 24, bottom: 16 }}
      alignItems={'center'}
      gap={20}
    >
      <Flex alignItems={'center'} gap={8} width={width * 0.8}>
        <IconCircleCheckFilled size={60} fill={Colors.content_blue_primary} />
        <Typography type={'subtitle3'} color={'content_blue_primary'}>
          {'아이디 찾기 결과입니다!'}
        </Typography>
        <Typography type={'h4'} color={'content_primary'}>
          {param.email}
        </Typography>

        <Flex margin={{ top: 24 }}>
          <Typography
            type={'body2'}
            color={'content_tertiary'}
            textAlign={'center'}
          >
            {'개인정보 보호를 위해 뒷자리는 ***으로 표시합니다.\n' +
              '전체 아이디 찾기를 원하시면 문의를 남겨주세요.\n' +
              '카카오톡 채널: 에이블리 고객지원센터'}
          </Typography>
        </Flex>
      </Flex>
      <Flex width={'100%'}>
        <PrimaryButton
          variant={'fill'}
          color={'gray'}
          size={'medium'}
          onPress={confirm}
        >
          {'확인'}
        </PrimaryButton>
      </Flex>
    </Flex.Column>
  );
};

export const useRecoveryIdResultPopup = createCreateUseModal({
  modalProps: {
    coverScreen: isWeb,
    style: {
      margin: 0,
      padding: 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    deviceWidth: isWeb ? Dimensions.get('window').width : undefined,
    animationIn: 'zoomIn',
    animationOut: 'zoomOut',
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: false,
  cancelOnBackdropPress: false,
})<void, RecoveryIdResultParam>(RecoveryIdResultContent);
